/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-sidenav-container[_ngcontent-%COMP%]{padding-left:20px;height:100%}mat-sidenav-content[_ngcontent-%COMP%]{padding-right:20px}mat-sidenav[_ngcontent-%COMP%]{min-width:500px;overflow:auto}.fullscreen[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };
